import { render } from "./Main.vue?vue&type=template&id=1f0c4cfd&scoped=true&bindings={}"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=1f0c4cfd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1f0c4cfd"

export default script